import { createVanIconComponent } from "./van"

const GuideOutlined = createVanIconComponent("guide-o")
export default GuideOutlined
